import createIconComponent from './utils/createIconComponent';
import React from 'react';
const CorrectRelative = createIconComponent({
  height: 150,
  width: 210,
  content: (
    <g>
      <path d='M206.20859260899482,2.9821051053273493 c-4.086139111693342,-3.9761341004991095 -10.710940540157253,-3.9761341004991095 -14.797896825135012,0 L66.04957417761756,124.95730851923975 L17.862808005217573,78.07249679682911 c-4.086139111693342,-3.9761341004991095 -10.710940540157253,-3.9757363355637096 -14.797896825135012,0 c-4.086547922218642,3.9757363355637096 -4.086547922218642,10.421543253802326 0,14.397676482965323 l55.58571548049986,54.08306224768535 c4.084913127883624,3.9757363355637096 10.714619387118773,3.9729524166839667 14.797896825135012,0 L206.20859260899482,17.380177610555847 C210.29514321781056,13.404445196004644 210.29474201931038,6.958239641494515 206.20859260899482,2.9821051053273493 z' />
    </g>
  ),
});
CorrectRelative.displayName = 'CorrectRelative';
export default CorrectRelative;
